import * as React from 'react';
import { IframeCore, } from '@core-front/iframe';
import Button from '@telia-front/button';
import Heading from '@telia-front/heading';
import Notice from '@telia-front/notice';
import Overlay from '@telia-front/overlay';
import Text from '@telia-front/text';
export default class Iframe extends React.Component {
    render() {
        return (React.createElement(IframeCore, Object.assign({}, this.props, { components: {
                Button,
                Heading,
                Notice: (props) => React.createElement(Notice, Object.assign({}, props)),
                Overlay,
                Text,
            } })));
    }
}
